module.exports = __webpack_public_path__ + "media/images/member_google-c1bb504f4f2a69327a3591214db53286.svg";